import React, { useState } from 'react';
import { Mic, MessageCircle, X } from 'lucide-react';
import TranscribeMode from './TranscribeMode';
import SimpleAudioChat from './SimpleAudioChat';

const VoiceModeSelector = ({ onClose, existingConversation = [], conversationId, onSaveMessage }) => {
  const [selectedMode, setSelectedMode] = useState(null);

  if (selectedMode === 'transcribe') {
    return (
      <TranscribeMode
        onClose={onClose}
        onBack={() => setSelectedMode(null)}
        existingConversation={existingConversation}
      />
    );
  }

  if (selectedMode === 'audio_chat') {
    return (
      <SimpleAudioChat
        onClose={onClose}
      />
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Voice Features</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg text-gray-600 hover:text-gray-800 hover:bg-gray-100 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Mode Selection */}
        <div className="p-6 space-y-4">
          <p className="text-gray-600 text-sm mb-6">
            Choose how you'd like to use voice features:
          </p>

          {/* Transcribe Mode */}
          <button
            onClick={() => setSelectedMode('transcribe')}
            className="w-full p-4 border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all group"
          >
            <div className="flex items-start gap-4">
              <div className="p-3 bg-blue-100 rounded-lg group-hover:bg-blue-200 transition-colors">
                <Mic className="w-6 h-6 text-blue-600" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="font-semibold text-gray-900 mb-1">Transcribe Mode</h3>
                <p className="text-sm text-gray-600">
                  Convert speech to text. Speak and see your words appear in the message box to edit before sending.
                </p>
              </div>
            </div>
          </button>

          {/* Audio Chat Mode */}
          <button
            onClick={() => setSelectedMode('audio_chat')}
            className="w-full p-4 border-2 border-gray-200 rounded-lg hover:border-green-500 hover:bg-green-50 transition-all group"
          >
            <div className="flex items-start gap-4">
              <div className="p-3 bg-green-100 rounded-lg group-hover:bg-green-200 transition-colors">
                <MessageCircle className="w-6 h-6 text-green-600" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="font-semibold text-gray-900 mb-1">Audio Chat Mode</h3>
                <p className="text-sm text-gray-600">
                  Full voice conversation. Speak naturally and hear AI responses in real-time like ChatGPT voice mode.
                </p>
              </div>
            </div>
          </button>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <p className="text-xs text-gray-500 text-center">
            Both modes use OpenAI Realtime API for best quality speech processing
          </p>
        </div>
      </div>
    </div>
  );
};

export default VoiceModeSelector;